function CustomButton({ props }) {
  return (
    <button
      onClick={props.onClick}
      type="submit"
      className="w-full cursor-pointer font-bold px-4 py-2 bg-[#34699A] text-white rounded-lg hover:bg-[#9EC6F3] shadow-md transition-colors duration-200"
    >
      {props.title || "Button"}
    </button>
  );
}

export default CustomButton;
